import IStaffConfirmationStatus from '../model/staff-confirmation-status'

export const staffConfirmationStatusLocale = {
  [IStaffConfirmationStatus.Initialized]: 'загрузите паспорт',
  [IStaffConfirmationStatus.ProfileVerification]: 'проверка паспорта...',
  [IStaffConfirmationStatus.AgreementSigning]: 'загрузите подписанные документы',
  [IStaffConfirmationStatus.AgreementVerification]: 'проверка документов...',
  [IStaffConfirmationStatus.ProfileConfirmed]: 'регистрация завершена',
  [IStaffConfirmationStatus.ProfileRejected]: 'профиль деактивирован',
} satisfies Record<IStaffConfirmationStatus, string>
